import { render, staticRenderFns } from "./EntityLog.vue?vue&type=template&id=60ef54a6&scoped=true&"
import script from "./EntityLog.vue?vue&type=script&lang=js&"
export * from "./EntityLog.vue?vue&type=script&lang=js&"
import style0 from "./EntityLog.vue?vue&type=style&index=0&id=60ef54a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef54a6",
  null
  
)

export default component.exports